/**
 * `utils/smoothScroll.js`
 * - スムーズなスクロールの処理
 * - どこからでも使える汎用関数
 */


import {gsap} from "../modules/gsap/gsap.js";
import {mediaQuery} from "./device.js";


export function smoothScroll(hash, duration = 0.6, event) {
  console.log("🔥 smoothScroll triggered:", hash, event?.type); // 👀 これでイベント種別を確認

  event?.preventDefault(); // デフォルトのスクロールを防止

  // ヘッダーの高さ分オフセットを取得
  const offset = getHeaderOffset(mediaQuery());

  // ページトップへスクロール
  if (hash === "windowTop") {
    gsap.to(window, { duration, scrollTo: { y: 0 } });
    return;
  }

  // `hash` に `#` がない場合、自動補正
  if (!hash.startsWith("#")) {
    hash = `#${hash}`;
  }

  // 指定されたIDの要素へスクロール
  const target = document.querySelector(hash);
  if (target) {

    // lockscrollの影響（mainがposition fixedの場合）を考慮する
    const main = document.querySelector("#main");
    const mainStyle = window.getComputedStyle(main);
    let mainTop = 0; // `top` の値があれば使う
    if (mainStyle.getPropertyValue("position") === "fixed") {
      mainTop = parseFloat(mainStyle.getPropertyValue("top")); // `top` の値があれば使う
    }

    // 現在のスクロール位置を取得
    const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;

    // `offsetY` を考慮したスクロール位置を計算
    const targetPosition = (scrollTop || (mainTop * -1)) + target.getBoundingClientRect().top - offset;

    gsap.to(window, { duration, scrollTo: { y: targetPosition } });
  } else {
    console.warn(`smoothScroll: Target "${hash}" not found.`);
  }
}


/**
 * headerの高さ（調整用）取得
 */
export const getHeaderOffset = (mediaQuery) => {
  let header;
  let offset;

  if (mediaQuery === 'pc') {
    header = document.querySelector("#header");
    offset = header ? header.clientHeight : 0; // ヘッダーの高さを考慮
  } else {
    header = document.querySelector("#header");
    offset = header ? header.clientHeight : 0; // ヘッダーの高さを考慮
  }

  return offset;
}